export const TRAILS_OPTIONS = {
  noTrails: 1,
  selectedTrails: 2,
  selectedTrailsIcons: 3,
  allTrailsIcons: 4
};
